/* global axios */

import ApiClient from './ApiClient';

class CannedFile extends ApiClient {
  constructor() {
    super('canned_files', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }
}

export default new CannedFile();
